module.exports = "https://bin.bnbstatic.com/_next/static/images/NPXS_landing-EN-d5a289d71a3b1f92ca33b60d5ecaf19f.jpg";